export class TeamMemberSuggestion {
    userId: number;
    teamName: string;
    email: string;
    fullName: string;
}
